import { axiosRequest } from '@planbord/axios-request';
import { useMutation } from '@tanstack/vue-query';

export const useDeleteRemark = () => {
    const baseUrl = '/api';
    
    return useMutation({
        mutationFn: (value: { ScheduleId: number }) =>
        axiosRequest
            .delete(`${baseUrl}/remarks/${value.ScheduleId}`)
            .then((res) => {
            return { data: res.data, status: res.status}
            }),
    });
}